import * as React from "react";
import {DynamicDialog, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {css,cx} from "emotion";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {IconData} from "../../PageBuilderPr/Controls/IconControl.Options";

let Figures:{Label:string,Value:string}[]=[{Label:'square',Value:'square'},{Label:"PayPal",Value:"paypal"},{Label:"WhatsApp",Value:"whatsapp"},{Label:"Visa",Value:"visa"},{Label:"Cart",Value:"cart"},{Label:"Comment",Value:"comment"},{Label:"AmericanExpress",Value:"americanexpress"},{Label:"Heart",Value:"heart"},{Label:"Heart 2",Value:"heart2"},{Label:"Tag",Value:"tag"},{Label:"Tag 2",Value:"tag2"},{Label:"Tag 3",Value:"tag3"},{Label:"Tag 4",Value:"tag4"},{Label:"Tag 5",Value:"tag5"},{Label:"Tag 6",Value:"tag6"},{Label:"Tag 7",Value:"tag7"},{Label:"Store",Value:"store"},{Label:"Sale",Value:"sale"},{Label:"Paid",Value:"paid"},{Label:"Paid 2",Value:"paid2"},{Label:"Payment Required",Value:"paymentrequired"},{Label:"Payment Required 2",Value:"paymentrequired2"},{Label:"Past Due",Value:"pastdue"},{Label:"Padt Due 2",Value:"pastdue2"},{Label:"Urgent",Value:"urgent"},{Label:"Due",Value:"due"},{Label:"Due 2",Value:"due2"},{Label:"Best Seller",Value:"bestseller"},{Label:"Cart 2",Value:"cart2"},{Label:"Bag",Value:"bag"},{Label:"Store 2",Value:"store2"},{Label:"Android",Value:"android"},{Label:"Dollar",Value:"dollar"},{Label:"American Express 2",Value:"amex"},{Label:"Basket",Value:"basket"},{Label:"Important",Value:"important"},{Label:"Important 2",Value:"important2"},{Label:"Important 3",Value:"important3"},{Label:"Important 4",Value:"important4"},{Label:"Thank you",Value:"thankyou"},{Label:"Time",Value:"time"},{Label:"Delivery",Value:"delivery"},{Label:"Delivery 2",Value:"delivery2"},{Label:"Coupon",Value:"coupon"},{Label:"Voucher",Value:"voucher"},{Label:"You Tube",Value:"youtube"},{Label:"Box",Value:"box2"},{Label:"Gift",Value:"gift"},{Label:"Gift 2",Value:"gift2"},{Label:"Star",Value:"star"},{Label:"Star 2",Value:"star2"}];
library.add(faTimes);
library.add(faSearch);
export class FigureDialog extends DynamicDialog<any,IconDialogState> {
    static defaultProps: Partial<IconDialogProps> = {};

    constructor(props: IconDialogProps) {
        super(props);
        this.state = {
            IsOpen:true,
            IconToSearch:''
        };
    }


    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Icons',
            Styles:{
                width:'80%',
                maxWidth:1200
            },
            FooterArea:this.GetFooter()
        };
    }

    SubRenderer(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        let listToShow=Figures;
        if(this.state.IconToSearch)
            listToShow=listToShow.filter(x=>x.Label.toLowerCase().indexOf(this.state.IconToSearch.toLowerCase())>=0 );
        return (
            <div style={{display:'flex',justifyContent:"center",flexWrap:'wrap'}}>
                {listToShow.map(x=>
                    <div className={css`
                        cursor: pointer;
                        &:hover{
                          color: red;
                        }
                        
                    `} key={x.Value} style={{padding:10,textAlign:'center',userSelect:'none'}} onClick={e=>
                        this.ItemSelected(x as any)
                    }>
                        <div className={css`
                                          border:1px solid #dfdfdf;
                                          &:hover{
                                          border-color:red;
                                          }`} style={{height:100,display:'flex',alignItems:'middle'}}>
                            <img style={{width:100}}  src={rednaoVar.URL+'pr/images/figures/'+x.Value} />
                        </div>
                        <span style={{fontSize:12,display:'block'}}>{x.Label}</span>
                    </div>
                )}
            </div>
        );
    }

    private GetFooter() {
        return (
            <div style={{width:'100%',justifyContent:'space-between',display:'flex'}}>
                <div style={{width:300,display:'inline-block',position:'relative'}}>
                    <FontAwesomeIcon icon={"search"} style={{position:'absolute',fontSize:20,top:6,left:5,color:'#b5b5b5'}}/>
                    <input value={this.state.IconToSearch} onChange={e=>this.setState({IconToSearch:e.target.value})} style={{width:'100%',paddingLeft:30}} type={'text'} placeholder={"Icon Search"}/>
                </div>
                <button onClick={e=>this.SendResult(null)} className={'rnbtn rnbtn-danger'}><FontAwesomeIcon icon={"times"}/> Cancel</button>
            </div>
        )
    }

    private ItemSelected(figureItem: { Label: string; Value: string; type: string,Svg:string }) {
        let figureToLoad=figureItem.Value;
        jQuery.get(rednaoVar.URL+'pr/images/figures/'+figureItem.Value+'.svg',(data)=>{
            if(figureItem.Value!=figureToLoad)
                return;
            figureItem.Svg=jQuery(data).find('svg')[0].outerHTML;
            this.SendResult(figureItem);
        });
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface IconDialogProps {

}

interface IconDialogState  extends DynamicDialogState{
    IconToSearch:string;
}



//#endregion "My Region"